import store from "./store";
import axios_http from "axios";

/* eslint-disable */
const axios = axios_http;

store.subscribe((mutation) => {
  switch (mutation.type) {
    case "auth/SET_TOKEN":
      if (mutation.payload) {
        axios.defaults.headers.common["X-AUTH-TOKEN"] = mutation.payload;
        localStorage.setItem("token", mutation.payload);
      } else {
        axios.defaults.headers.common["X-AUTH-TOKEN"] = null;
        localStorage.removeItem("token");
      }
      break;
  }
});
